import { Input, DatePicker, Select } from 'antd';

import { Form, StyledModal, WrapperSelect } from 'common/components';

import * as constants from 'static/Constants';

import { DOCUMENT_CERTIFICATE_LIMIT_CHARACTER } from 'pages/qa-spec/constant';

import { QaSpecHelpContentLabel } from 'pages/qa-spec/components/shared/QaSpecHelpContent';

import * as Const from 'static/Constants';
import { TOOlTIP_FIELDS } from 'static/tooltipFields';
import TraceableCommentContainer from 'pages/traceable-comment/TraceableCommentContainer';
import { getFormattedPath } from '../shared/QaSpecHelper';
import { useGetCertificateTypes } from 'pages/company-profile/components/tabs/contacts/companyCertificate/queries';

const ModalUpdateDocumentOrCertification = ({
  type,
  formInstance,
  isRequiredExpiryDate = false,
  ...otherProps
}) => {
  const renderFormItemDocument = () => {
    return (
      <Form
        form={formInstance}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
      >
        <Form.Item
          noStyle
          shouldUpdate={(prevValues, currentValues) =>
            prevValues !== currentValues
          }
        >
          {() => {
            const options = Const.QA_SPEC_DOCUMENT_SUBTYPE.sort();

            return (
              <Form.Item
                name={'subtype'}
                label={
                  <TraceableCommentContainer
                    qaSpecName={getFormattedPath(
                      TOOlTIP_FIELDS.certificateSubType.fieldPath
                    )}
                    qaSpecFieldName='Sub Type'
                  >
                    <QaSpecHelpContentLabel
                      fieldPath={TOOlTIP_FIELDS.certificateSubType.fieldPath}
                    >
                      Sub Type:
                    </QaSpecHelpContentLabel>
                  </TraceableCommentContainer>
                }
                rules={[
                  {
                    required: true,
                    message: 'Please select asset subtype',
                  },
                ]}
              >
                <WrapperSelect>
                  {options.map((item, index) => {
                    return (
                      <Select.Option value={item} key={index}>
                        {item}
                      </Select.Option>
                    );
                  })}
                </WrapperSelect>
              </Form.Item>
            );
          }}
        </Form.Item>

        <Form.Item
          label={
            <TraceableCommentContainer
              qaSpecName={getFormattedPath(
                TOOlTIP_FIELDS.documentName.fieldPath
              )}
              qaSpecFieldName='Document Name'
            >
              <QaSpecHelpContentLabel
                fieldPath={TOOlTIP_FIELDS.documentName.fieldPath}
              >
                Document Name
              </QaSpecHelpContentLabel>
            </TraceableCommentContainer>
          }
          name='documentName'
        >
          <Input />
        </Form.Item>
      </Form>
    );
  };

  const renderFormItemCertification = () => {
    const { data, isLoading, isError } = useGetCertificateTypes();
    return (
      <Form
        form={formInstance}
        labelCol={{ span: 10 }}
        wrapperCol={{ span: 14 }}
      >
        <Form.Item
          name='certificateType'
          label={
            <TraceableCommentContainer
              qaSpecName={getFormattedPath(
                TOOlTIP_FIELDS.certificateType.fieldPath
              )}
              qaSpecFieldName='Certificate Type'
            >
              <QaSpecHelpContentLabel
                fieldPath={TOOlTIP_FIELDS.certificateType.fieldPath}
              >
                Certificate Type
              </QaSpecHelpContentLabel>
            </TraceableCommentContainer>
          }
        >
          <WrapperSelect
            showSearch
            filterOption={(input, option) =>
              (option?.children ?? "")
                .toLowerCase()
                .includes(input.toLowerCase())
            }
            loading={isLoading}
            allowClear
          >
            {data?.map((item) => (
              <Select.Option key={item} value={item}>
                {item}
              </Select.Option>
            ))}
          </WrapperSelect>
        </Form.Item>
        <Form.Item
          label={
            <TraceableCommentContainer
              qaSpecName={getFormattedPath(
                TOOlTIP_FIELDS.certificateName.fieldPath
              )}
              qaSpecFieldName='Certificate Name'
            >
              <QaSpecHelpContentLabel
                fieldPath={TOOlTIP_FIELDS.certificateName.fieldPath}
              >
                Certificate Name
              </QaSpecHelpContentLabel>
            </TraceableCommentContainer>
          }
          name='certificate'
        >
          <Input />
        </Form.Item>
        <Form.Item
          label={
            <TraceableCommentContainer
              qaSpecName={getFormattedPath(
                TOOlTIP_FIELDS.certificateBody.fieldPath
              )}
              qaSpecFieldName='Certificate Body'
            >
              <QaSpecHelpContentLabel
                fieldPath={TOOlTIP_FIELDS.certificateBody.fieldPath}
              >
                Certificate Body
              </QaSpecHelpContentLabel>
            </TraceableCommentContainer>
          }
          name='certificateBody'
        >
          <Input
            showCount
            maxLength={DOCUMENT_CERTIFICATE_LIMIT_CHARACTER.certificateBody}
          />
        </Form.Item>
        <Form.Item
          label={
            <TraceableCommentContainer
              qaSpecName={getFormattedPath(
                TOOlTIP_FIELDS.certificateExpiryDate.fieldPath
              )}
              qaSpecFieldName='Certificate Expiry Date'
            >
              <QaSpecHelpContentLabel
                fieldPath={TOOlTIP_FIELDS.certificateExpiryDate.fieldPath}
              >
                Certificate Expiry Date
              </QaSpecHelpContentLabel>
            </TraceableCommentContainer>
          }
          name='certificateExpiryDate'
          rules={[
            {
              required: isRequiredExpiryDate,
              message: 'Please select Certificate Expiry Date',
            },
          ]}
        >
          <DatePicker format={constants.DATE_FORMAT.SYSTEM_FORMAT} />
        </Form.Item>
      </Form>
    );
  };

  return (
    <StyledModal title='Update Document' {...otherProps}>
      {type === 'document'
        ? renderFormItemDocument()
        : renderFormItemCertification()}
    </StyledModal>
  );
};

export default ModalUpdateDocumentOrCertification;
